var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.dismissed ? _c('v-alert', {
    staticClass: "info-alert notice-alert text-body-2 mb-4",
    "class": {
      'info-alert--dismissible': _vm.dismissKey
    },
    style: _vm.noticeStyle,
    attrs: {
      "border": "left",
      "colored-border": "",
      "color": _vm.defaultColor,
      "elevation": _vm.elevation,
      "type": _vm.type,
      "icon": _vm.noIcon ? null : _vm.icon || 'info'
    }
  }, [_vm.dismissKey ? _c('v-btn', {
    staticClass: "info__dismiss",
    attrs: {
      "icon": "",
      "small": "",
      "aria-label": _vm.$i18n.locale.startsWith('fr') ? 'Masquer ce message' : 'Dismiss this message'
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close")])], 1) : _vm._e(), _c('div', {
    staticClass: "info__layout ml-2"
  }, [_c('div', {
    staticClass: "info__text"
  }, [_vm.title ? _c('strong', {
    staticClass: "d-block"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm.summary ? _c('p', {
    staticClass: "mt-2 mb-0"
  }, [_vm._v(_vm._s(_vm.summary))]) : _vm._e(), _vm.collapsible ? _c('button', {
    staticClass: "info__toggle",
    attrs: {
      "aria-expanded": _vm.expanded,
      "aria-controls": "info-details-".concat(_vm._uid)
    },
    on: {
      "click": function click($event) {
        _vm.expanded = !_vm.expanded;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$i18n.locale.startsWith('fr') ? _vm.expanded ? 'Réduire' : 'En savoir plus' : _vm.expanded ? 'Show less' : 'Learn more') + " "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1) : _vm._e(), _vm.collapsible ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.expanded,
      expression: "expanded"
    }],
    staticClass: "mt-3",
    attrs: {
      "id": "info-details-".concat(_vm._uid)
    }
  }, [_vm._t("default")], 2) : _vm._t("default")], 2), !_vm.noButton ? _c('div', {
    staticClass: "info__actions"
  }, [_vm._t("button")], 2) : _vm._e()])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }